import { Avatar } from './avatar';

export const media = {
  Avatar,
};
